type Node = {id:string;name:string;code:string|null;parentId:string|null};
/** Stable preorder with explicit depth/path; orphaned/cyclic rows remain visible. */
export function accountHierarchy<T extends Node>(accounts:T[]){
 const nodes=new Map(accounts.map(a=>[a.id,a])),seen=new Set<string>();
 const result:{account:T;depth:number;path:string}[]=[];
 const sorted=[...accounts].sort((a,b)=>(a.code||'').localeCompare(b.code||'',undefined,{numeric:true})||a.name.localeCompare(b.name));
 const visit=(account:T,depth:number,path:string[])=>{
  if(seen.has(account.id))return;seen.add(account.id);const names=[...path,account.name];
  result.push({account,depth,path:names.join(' / ')});
  for(const child of sorted.filter(a=>a.parentId===account.id))visit(child,depth+1,names);
 };
 for(const root of sorted.filter(a=>!a.parentId||!nodes.has(a.parentId)))visit(root,0,[]);
 for(const remainder of sorted)visit(remainder,0,[]);
 return result;
}
